import { useFormController } from '@dreryk/react-common';

import { INITIAL_FORM_VALUES } from './NfzMfaForm.constants';
import { NfzMfaFormBean, NfzMfaFormController, NfzMfaTotpErrorSetter } from './NfzMfaForm.types';

type UseNfzMfaFormReturn = Pick<NfzMfaFormController, 'register' | 'handleSubmit'> & {
   setMfaTotpError: NfzMfaTotpErrorSetter;
};

export const useNfzMfaForm = (): UseNfzMfaFormReturn => {
   const { register, handleSubmit, setError } = useFormController<NfzMfaFormBean>(INITIAL_FORM_VALUES);

   const setMfaTotpError: NfzMfaTotpErrorSetter = (message) => {
      setError('mfaTotp', { message: message });
   };

   return {
      register: register,
      handleSubmit: handleSubmit,
      setMfaTotpError: setMfaTotpError,
   };
};
